/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");
export const LOCATION_NOT_FOUND = require('./res/images/locationNotFound.png');


export const CREDENTIAL_GEO_FENCED = require('./res/images/geo.png');
export const CREDENTIAL_WEBSITE = require('./res/images/website.png');
export const CREDENTIAL_FFEDBACK = require('./res/images/feedback.png');
export const CREDENTIAL_MENU = require('./res/images/menu-white.png');

export const TRACK_LOADER_LOTTIE = require('./res/lotties/track.json');

export const LOADING_IMAGE = require("./res/images/loading-img.png");
export const NO_IMAGE = require('./res/images/no-image.png');

export const TRAG_LIGHT_LOGO = require('./res/images/trag-2.png');
export const PRODUCT_JOURNEY = require('./res/images/product_journey.png');
export const PROTECT_B_AND_C = require('./res/images/Protect_brand_and_customer.png');
export const TRAG_ILLUSTRATION = require('./res/images/trag-illustration.png');
export const TRAG_LOGO = require('./res/images/trag.png');
export const TRANSPARENCY = require('./res/images/Transparency.png');
export const BANNER_IMAGE = require('./res/images/bg.png');
export const AUTHENTICITY = require('./res/images/Authenticity.png');
export const EFFICIENCY = require('./res/images/Efficiency.png');
export const CUSTOMER_ENGAGEMENT = require('./res/images/Customer_Engagement.png');
export const ELEVATE_CE = require('./res/images/Elevate_customer_experience.png');
export const VIDEO =require('./res/images/default-video.png');
export const THUMB_NAIL = require('./res/images/v_tn.png');
export const QR_IMAGE = require('./res/images/qr.png');

export const LEAF_LOGO = require('./res/images/leaf.png');
export const BATCH_LOGO = require('./res/images/paper.png');
export const DATE_LOGO = require('./res/images/calendar-2.png');
export const BARCODE_LOGO = require('./res/images/barcode.png');
export const PLT_STORY_LOGO = require('./res/images/diageo-logo.png');
export const THREE_SIXTY_LOGO = require('./res/images/360-degrees.png');
export const LARGE_SCREEN_BG = require('./res/images/threed-bg.jpeg');
export const SMALL_SCREEN_BG = require('./res/images/mobile-bg.png');
export const LARGE_SCREEN_BG_1 = require('./res/images/LG-bg.png');
export const LOAD_SIGNATURE = require('./res/images/load-sign.png');

export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    LOCATION_NOT_FOUND,
    LOADING_IMAGE,
    NO_IMAGE,
    TRAG_LIGHT_LOGO,
    PRODUCT_JOURNEY,
    PROTECT_B_AND_C,
    TRAG_ILLUSTRATION,
    TRAG_LOGO,
    TRANSPARENCY,
    BANNER_IMAGE,
    AUTHENTICITY,
    EFFICIENCY,
    CUSTOMER_ENGAGEMENT,
    ELEVATE_CE,
    VIDEO,
    THUMB_NAIL,
    QR_IMAGE,
    LEAF_LOGO,
    BARCODE_LOGO,
    BATCH_LOGO,
    DATE_LOGO,
    THREE_SIXTY_LOGO,
    LARGE_SCREEN_BG_1,
    LOAD_SIGNATURE
];

